import { baseApi } from "@shared/api"

interface Request {
    startDate: string
    endDate: string
}

interface Response {
    fileBase64: string
    fileName: string
    mimeType: string
}

export const excelExportApi = baseApi.injectEndpoints({
    endpoints(builder) {
      return {
        excelExport: builder.mutation<Response, Request>({
          query: data => ({
            url: '/ib/order/acquiring/report/excel',
            method: 'POST',
            data,
            skipGlobalError: true,
          }),
        }),
      }
    },
  })

export const { useExcelExportMutation } =
  excelExportApi
